import React, { useEffect, useState } from "react";
import { imageCompresser } from "utils/ImageCompressor";
import { apiURL } from "constants/config";
import { CiImageOff } from "react-icons/ci";
import { FaCloudUploadAlt } from "react-icons/fa";

export interface IImageUploadProps {
  name: string;
  onChange?: (file: File | null) => void;
  values?: any;
  errors?: any;
  touches?: any;
}

export const ImageUpload: React.FC<IImageUploadProps> = ({
  name,
  onChange,
  values,
  errors,
  touches,
}) => {
  const [imagePreview, setImagePreview] = useState<string | null>(null);

  useEffect(() => {
    if (!imagePreview && values?.[name]) {
      setImagePreview(
        `${apiURL}/${values?.[name]}?v=${new Date().getTime()}`
      );
    }
  }, [values?.[name], imagePreview]);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        setImagePreview(reader.result as string);
        if (onChange) {
          const compressed = await imageCompresser(file);
          onChange(compressed[0]);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex">
      <div className="justify-start items-start mt-2">
        <div className=" bg-white">
          <input
            type="file"
            name={name}
            id="image"
            accept="image/*"
            className="sr-only"
            onChange={handleImageChange}
          />
          <label
            htmlFor="image"
            className="flex  items-center justify-center rounded-lg bg-gray-50 border-2 border-dashed border-blue-950 w-44 h-44 cursor-pointer"
          >
            {imagePreview ? (
              <img
                src={`${imagePreview}`} //
                alt="Selected"
                className="h-full w-full object-cover rounded-md"
              />
            ) : (
              <div className="text-[20px] flex flex-col items-center">
                <div className="text-[12px] font-poppinsMedium text-gray-600 text-center">
                  Click here to upload Image
                </div>
              </div>
            )}
          </label>
        </div>
        {touches?.[name] && errors?.[name] && (
          <div
            style={{ color: "#ef4444" }}
            className="font-bold text-[10px] mb-10"
          >
            {errors[name]}
          </div>
        )}
      </div>
    </div>
  );
};
